// Subtle swirling-circle watermark inspired by the Ikas Corp branding doc.
// Overlapping translucent circles in the brand palette. Purely decorative — pointer-events: none.
export default function BrandWatermark({ size = 320, className = '', opacity = 0.18 }) {
    return (
        <svg
            viewBox="0 0 300 300"
            width={size}
            height={size}
            aria-hidden="true"
            className={`pointer-events-none select-none ${className}`}
            style={{ opacity }}
        >
            {/* Peach outer arc */}
            <path
                d="M150,20 a130,130 0 1,1 -110,180"
                fill="none"
                stroke="#fab06c"
                strokeWidth="26"
                strokeLinecap="round"
            />
            {/* Coral orange crescent */}
            <path
                d="M60,90 a110,110 0 1,1 40,180"
                fill="none"
                stroke="#dd683d"
                strokeWidth="22"
                strokeLinecap="round"
            />
            {/* Deep teal ring */}
            <path
                d="M240,90 a90,90 0 1,1 -160,90"
                fill="none"
                stroke="#016a6d"
                strokeWidth="18"
                strokeLinecap="round"
            />
            {/* Vibrant teal inner ring */}
            <circle cx="150" cy="150" r="68" fill="none" stroke="#189290" strokeWidth="14" />
            {/* Sky blue crescent */}
            <path
                d="M100,150 a50,50 0 1,0 100,20"
                fill="none"
                stroke="#78aede"
                strokeWidth="10"
                strokeLinecap="round"
            />
            {/* Deep blue inner arc */}
            <path
                d="M120,120 a35,35 0 1,1 60,50"
                fill="none"
                stroke="#043e52"
                strokeWidth="8"
                strokeLinecap="round"
            />
        </svg>
    );
}
